"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatePromoCodeRequestToJSON = exports.ValidatePromoCodeRequestFromJSONTyped = exports.ValidatePromoCodeRequestFromJSON = void 0;
function ValidatePromoCodeRequestFromJSON(json) {
    return ValidatePromoCodeRequestFromJSONTyped(json, false);
}
exports.ValidatePromoCodeRequestFromJSON = ValidatePromoCodeRequestFromJSON;
function ValidatePromoCodeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'promoCode': json['promoCode'],
    };
}
exports.ValidatePromoCodeRequestFromJSONTyped = ValidatePromoCodeRequestFromJSONTyped;
function ValidatePromoCodeRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'promoCode': value.promoCode,
    };
}
exports.ValidatePromoCodeRequestToJSON = ValidatePromoCodeRequestToJSON;
//# sourceMappingURL=ValidatePromoCodeRequest.js.map